import React from 'react';
import { MockCard, MockHeader, MeterBar, StaggerRow } from './shell';

const ITEMS = [
  {
    name: 'Resolute 8+ \u00b7 \u201cBergman\u201d',
    meta: 'Club boat \u00b7 Varsity',
    meters: '148,320 m',
    pct: 74,
    status: { label: 'Out 5:45\u20137:15', tone: 'bg-blue-50 text-blue-700 ring-blue-100' },
    bar: 'bg-blue-600',
  },
  {
    name: 'Filippi 4x \u00b7 \u201cKelly\u201d',
    meta: 'Club boat \u00b7 Masters',
    meters: '96,540 m',
    pct: 48,
    status: { label: 'Available', tone: 'bg-emerald-50 text-emerald-700 ring-emerald-100' },
    bar: 'bg-emerald-500',
  },
  {
    name: 'Vespoli 2\u2212 \u00b7 \u201cSchuylkill\u201d',
    meta: 'Private \u00b7 A. Bianchi',
    meters: '41,880 m',
    pct: 21,
    status: { label: 'Damage: monitor', tone: 'bg-amber-50 text-amber-700 ring-amber-100' },
    bar: 'bg-amber-500',
  },
  {
    name: 'Concept2 RowErg #14',
    meta: 'Erg bay \u00b7 slide-ready',
    meters: '212,600 m',
    pct: 92,
    status: { label: 'Out of service', tone: 'bg-rose-50 text-rose-700 ring-rose-100' },
    bar: 'bg-rose-500',
  },
];

export default function EquipmentMockup() {
  return (
    <MockCard>
      <MockHeader
        title="Boathouse inventory"
        subtitle={'34 hulls, blades & ergs \u00b7 season to date'}
        right={
          <span className="shrink-0 rounded-md bg-slate-900 px-2.5 py-1 text-[11px] font-semibold text-white">
            + Reserve
          </span>
        }
      />

      <div className="divide-y divide-slate-100">
        {ITEMS.map((item, i) => (
          <StaggerRow key={item.name} index={i} className="px-4 py-3">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-slate-900">{item.name}</p>
                <p className="truncate text-[11px] text-slate-500">{item.meta}</p>
              </div>
              <span
                className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ring-inset ${item.status.tone}`}
              >
                {item.status.label}
              </span>
            </div>
            <div className="mt-2 flex items-center gap-3">
              <MeterBar pct={item.pct} className={item.bar} delay={0.1 + i * 0.08} />
              <span className="shrink-0 font-mono text-[11px] text-slate-500">{item.meters}</span>
            </div>
          </StaggerRow>
        ))}
      </div>

      <div className="flex items-center justify-between bg-slate-50/70 px-4 py-2.5 text-[11px] text-slate-500">
        <span>Meters attributed to all 9 seats</span>
        <span className="font-semibold text-slate-700">2 open damage reports</span>
      </div>
    </MockCard>
  );
}
